import { ViewMode } from '../constants';
import { get, post, put, remove as httpRemove } from '../Services/http';
import { catchError } from './Error.action';
import { DEALER_INFO_RECEIVE, DEALER_INFO_ERROR, DEALER_INFO_CHANGE_MODE } from '../constants';

const rootRoute = '/api/dealerpage';

export const changeMode = (mode) => ({
    type: DEALER_INFO_CHANGE_MODE,
    payload: {
        mode,
    },
});

export const query = () => (dispatch) => {
    return get(rootRoute)
        .then((response) => response.json())
        .then((result) => {
            dispatch(receive(result));
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

const receive = (list) => ({
    type: DEALER_INFO_RECEIVE,
    payload: {
        list,
    },
});

export const setError = (error) => ({
    type: DEALER_INFO_ERROR,
    payload: {
        error,
    },
});
